import React from 'react'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const Vendor = () => {

  const navigate = useNavigate();
  const userInfo = useSelector(state => state.mainToCard.userInfo)

  React.useLayoutEffect(() => {
    if (userInfo?.userType === 0 && userInfo?.vendorId !== 0) {
      navigate(`/vendors/${userInfo?.vendorId}`)
    } else if (userInfo?.userType === 0 && userInfo?.vendorId === 0) {
      navigate(`/supplier-evaluation`)
    }
    else {
      navigate(`/vendors`)
    }
  }, [userInfo, navigate])

  return (
    <div>Vendor</div>
  )
}

export default Vendor